import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
    const heroRef = useRef(null);

    const [heroExpanded, setHeroExpanded] = useState(false);
    const [email, setEmail] = useState("");

    const year = new Date().getFullYear();

    // Variable de contrôle (tu peux changer ici)
    const HERO_MAX_HEIGHT = "320px"; // ex: "280px", "40vh", "420px"

    const scrollToTop = () => {
        if (typeof window !== "undefined") {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }
    };

    const onSubscribe = (e) => {
        e.preventDefault();

        // TODO: brancher ton endpoint newsletter
        console.log("Newsletter subscribe:", email);

        setEmail("");
    };

    useEffect(() => {
        const el = heroRef.current;
        if (!el) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                setHeroExpanded(entry.isIntersecting);
            },
            {
                root: null,
                // La zone active commence quand le bloc approche du bas de l'écran
                // et se désactive quand il en sort en remontant
                rootMargin: "0px 0px -20% 0px",
                threshold: 0.2,
            }
        );

        observer.observe(el);

        return () => observer.disconnect();
    }, []);

    return (
        <footer className="tc-footer" aria-label="Pied de page">
            <div className="tc-footer__inner">
                {/* HERO */}
                <div
                    ref={heroRef}
                    className={`tc-footer__hero ${heroExpanded ? "is-revealed" : ""}`}
                    style={{ "--footer-hero-max-height": HERO_MAX_HEIGHT }}
                >
                    <p className="tc-footer__kicker">Prêt à collaborer ?</p>

                    <div className="tc-footer__titleRow">
                        <h2 className="tc-footer__title">Démarrer un projet</h2>
                        <Link
                            className="tc-footer__arrow"
                            to="/"
                            state={{ openHeaderMenu: "contact" }}
                            aria-label="Ouvrir le menu Contact"
                        >
                            ↗
                        </Link>
                    </div>
                </div>

                <hr className="tc-footer__divider" />

                {/* GRID */}
                <div className="tc-footer__grid">
                    {/* Col 1: badge / logo */}
                    <div className="tc-footer__col">
                        <div className="tc-footer__mark" aria-label="ToCreate">
                            <div className="tc-footer__markCircle" aria-hidden="true">
                                TC
                            </div>
                            <div className="tc-footer__markText"></div>
                        </div>
                    </div>

                    {/* Col 2: Contact */}
                    <div className="tc-footer__col">
                        <ul className="tc-footer__list">
                            <li>
                                <a className="tc-footer__link" href="tel:+33100000000">
                                    +33 1 00 00 00 00
                                </a>
                            </li>
                            <li>
                                <a className="tc-footer__link" href="mailto:contact@tocreate.fr">
                                    contact@tocreate.fr
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Col 3: Social */}
                    <div className="tc-footer__col">
                        <ul className="tc-footer__list tc-footer__socialList" aria-label="Réseaux sociaux">
                            <li>
                                <a
                                    className="tc-footer__socialLink"
                                    href="https://instagram.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Instagram"
                                    data-label="Instagram"
                                >
                                    {/* Instagram */}
                                    <svg
                                        className="tc-footer__socialIcon"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        focusable="false"
                                    >
                                        <path d="M7.75 2h8.5A5.75 5.75 0 0 1 22 7.75v8.5A5.75 5.75 0 0 1 16.25 22h-8.5A5.75 5.75 0 0 1 2 16.25v-8.5A5.75 5.75 0 0 1 7.75 2Zm0 1.5A4.25 4.25 0 0 0 3.5 7.75v8.5a4.25 4.25 0 0 0 4.25 4.25h8.5a4.25 4.25 0 0 0 4.25-4.25v-8.5a4.25 4.25 0 0 0-4.25-4.25h-8.5Zm8.88 1.12a1.13 1.13 0 1 1 0 2.26 1.13 1.13 0 0 1 0-2.26ZM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10Zm0 1.5A3.5 3.5 0 1 0 12 15.5 3.5 3.5 0 0 0 12 8.5Z" />
                                    </svg>
                                </a>
                            </li>

                            <li>
                                <a
                                    className="tc-footer__socialLink"
                                    href="https://linkedin.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="LinkedIn"
                                    data-label="LinkedIn"
                                >
                                    {/* LinkedIn */}
                                    <svg
                                        className="tc-footer__socialIcon"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        focusable="false"
                                    >
                                        <path d="M6.94 8.5H3.56V20h3.38V8.5ZM5.25 3A2 2 0 1 0 5.3 7a2 2 0 0 0-.05-4ZM20.44 12.98c0-3.12-1.67-4.57-3.89-4.57a3.37 3.37 0 0 0-3.03 1.67V8.5h-3.24V20h3.38v-6.2c0-1.63.31-3.2 2.33-3.2 1.98 0 2 1.85 2 3.3V20h3.45l-.01-7.02Z" />
                                    </svg>
                                </a>
                            </li>

                            <li>
                                <a
                                    className="tc-footer__socialLink"
                                    href="https://twitter.com"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="X (Twitter)"
                                    data-label="X (Twitter)"
                                >
                                    {/* X / Twitter */}
                                    <svg
                                        className="tc-footer__socialIcon"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                        focusable="false"
                                    >
                                        <path d="M18.9 2H22l-6.78 7.75L23.2 22h-6.25l-4.9-7.41L5.57 22H2.45l7.25-8.29L1 2h6.4l4.43 6.71L18.9 2Zm-1.1 18.1h1.73L6.44 3.8H4.58L17.8 20.1Z" />
                                    </svg>
                                </a>
                            </li>
                        </ul>
                    </div>

                    {/* Col 4: Newsletter */}
                    <div className="tc-footer__col tc-footer__col--wide">
                        <div className="tc-footer__blockTitle">Newsletter</div>

                        <form className="tc-footer__newsletter" onSubmit={onSubscribe}>
                            <label className="tc-footer__srOnly" htmlFor="tc-newsletter">
                                Email
                            </label>
                            <input
                                id="tc-newsletter"
                                className="tc-footer__input"
                                type="email"
                                placeholder="Email"
                                autoComplete="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                            <button className="tc-footer__btn" type="submit">
                                S’abonner
                            </button>
                        </form>
                    </div>

                    {/* Col 5: Top */}
                    <div className="tc-footer__col tc-footer__col--top">
                        <button
                            className="tc-footer__topBtn"
                            type="button"
                            onClick={scrollToTop}
                            aria-label="Remonter en haut de la page"
                        >
                            Top ↑
                        </button>
                    </div>
                </div>

                {/* BOTTOM LINE */}
                <div className="tc-footer__bottom">
                    <div className="tc-footer__bottomLeft">© {year} ToCreate</div>

                    <div className="tc-footer__bottomLinks">
                        <Link className="tc-footer__link" to="/mentions-legales">
                            Mentions légales
                        </Link>
                        <Link className="tc-footer__link" to="/politique-de-confidentialite">
                            Confidentialité
                        </Link>
                        <Link className="tc-footer__link" to="/politique-cookies">
                            Cookies
                        </Link>
                    </div>

                    <div className="tc-footer__bottomRight">Made with care</div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
